export function fieldNameHasSpecialCharacters(key: string) {
  return (
    key.indexOf('__dot__') > -1 ||
    key.indexOf('__cma__') > -1 ||
    key.indexOf('__apos__') > -1
  );
}
